// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9fb4e1ea","977":"8476f015"}[chunkId] + ".chunk.js";
};